<template>
    <div class="v-modal">
        <div class="v-modal__header">
            <span>Sector or Crop Selection</span>
            <div class="close" v-on:click="$emit('close')"></div>
        </div>
        <div class="v-modal__body">
            <div class="row">
                <div class="col-xs-12 col-sm-8 col-md-3 p-card" @click="selectMainCat('All')">
                    <div
                            class="box"
                            v-bind:class="{ active: selectedMainCrop && selectedMainCrop.name === 'All' }"
                    >
                        <div class="box__title">All Sectors</div>
                        <img src="../../assets/img/pie-chart.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-3 p-card" @click="selectMainCat('Agricultural')">
                    <div
                            class="box"
                            v-bind:class="{ active: selectedMainCrop && selectedMainCrop.name === 'Agricultural' }"
                    >
                        <div class="box__title">Agriculture</div>
                        <img src="../../assets/img/icons/crop_for_selector.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-3 p-card" @click="selectMainCat('Industrial')">
                    <div
                            class="box"
                            v-bind:class="{ active: selectedMainCrop && selectedMainCrop.name === 'Industrial' }"
                    >
                        <div class="box__title">Industry</div>
                        <img src="../../assets/img/icons/industry.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-3 p-card" @click="selectMainCat('Domestic')">
                    <div
                            class="box"
                            v-bind:class="{ active: selectedMainCrop && selectedMainCrop.name === 'Domestic' }"
                    >
                        <div class="box__title">Domestic</div>
                        <img src="../../assets/img/icons/domestic-water.svg" class="p-card--icon" alt/>
                        <div class="mask"></div>
                    </div>
                </div>
            </div>

            <div class="row agriculture__ct" v-if="isAgriculture">
                <div class="col-md-6 select-all">
                    <label for="selection-section">
                        <input id="selection-section" type="checkbox" v-model="showCropSelectionSection"
                               @change="changeSpecific"/> Select a specific crop
                    </label>
                </div>
                <div class="col-md-6" v-if="showCropSelectionSection">
                    <multiselect
                            placeholder="Search crop to select"
                            label="name"
                            track-by="cropID"
                            @select="changeModel"
                            :options="selectOptions"
                    ></multiselect>
                </div>
            </div>
            <div class="row" v-if="isAgriculture">
                <br/>
                <br/>
                <div class="col-md-12" v-if="showCropSelectionSection">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="category">Crop Categories</div>
                        </div>
                        <div class="col-md-6" v-if="selectedSubCategories.length">
                            <div class="subcategory">Crop</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <ul class="category__list">
                                <li
                                        class="list-item"
                                        v-for="cat of categories"
                                        v-bind:key="cat.cropID"
                                        @click="changeModel(cat)"
                                        v-bind:class="{ active: selectedCrop.cropID === cat.cropID || selectedCrop.parentId === cat.cropID }"
                                >{{ cat.name }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6" v-if="selectedSubCategories.length">
                            <ul class="category__list">
                                <li
                                        class="list-item"
                                        v-for="cat of selectedSubCategories"
                                        v-bind:key="cat.cropID"
                                        v-bind:class="{ active: selectedCrop.cropID === cat.cropID }"
                                        @click="changeModel(cat)"
                                >{{ cat.name }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="v-modal__footer">
            <button class="button" @click="close()">Close</button>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import {crops} from "@/services/entity-model.js";
    import {assessment} from "@/services/assessment-model.js";
    import * as _ from "lodash";

    export default {
        name: "Crop",
        components: {
            Multiselect
        },
        data() {
            return {
                crops: crops,
                selectOptions: [],
                categories: [],
                selectedSubCategories: [],
                isAgriculture: false,
                selectedMainCrop: null,
                selectedCrop: null,
                showCropSelectionSection: false
            };
        },
        mounted() {
            const alreadySelected = assessment.crop;

            const tmpCategories = _.filter(
                this.crops,
                p => p.level === 3 || p.level === 4
            );
            this.selectOptions = [];
            this.categories = [];
            let mainCategory;
            let parentId = null;
            tmpCategories.forEach(cat => {
                if (cat.level === 3) {
                    parentId = cat.cropID;
                    if (mainCategory) {
                        this.categories.push(mainCategory);
                    }
                    mainCategory = cat;
                    mainCategory["subcategory"] = [];
                }

                if (cat.level === 4) {
                    cat.parentId = parentId;
                    mainCategory["subcategory"].push(cat);
                    this.selectOptions.push(cat);
                }
            });
            if (mainCategory) this.categories.push(mainCategory);
            this.initSelection(alreadySelected);
        },
        methods: {
            initSelection(crop) {
                if (!crop) {
                    return;
                }

                this.selectedCrop = crop;
                if (
                    crop.name === "Domestic" ||
                    crop.name === "Industrial" ||
                    crop.name === "All"
                ) {
                    return this.selectedMainCrop = crop;
                } else {
                    this.isAgriculture = true;
                    this.showCropSelectionSection = crop.name !== "Agricultural";
                    this.selectedMainCrop = _.find(this.crops, {name: "Agricultural"});

                    if (!this.showCropSelectionSection) {
                        return;
                    }
                    const parentCrop = crop.subcategory
                        ? crop
                        : _.find(this.crops, {cropID: crop.parentId});
                    this.selectedSubCategories = parentCrop.subcategory;
                }
            },
            selectMainCat: function (categoryName) {
                const cat = _.find(this.crops, {name: categoryName});

                this.isAgriculture = categoryName === "Agricultural";
                this.changeModel(cat);
            },
            changeModel: function (value) {
                assessment.crop = value;
                this.selectedCrop = value;

                if (value.parentId) {
                    this.selectedSubCategories = this.categories.find(cat => cat.cropID === value.parentId).subcategory;
                }
                if (value.subcategory) {
                    this.selectedSubCategories = value.subcategory;
                }

                if (value.level === 1 || value.level === 2) {
                    this.selectedMainCrop = value;
                    this.selectedSubCategories = [];
                }
            },
            changeSpecific: function () {
                if (!this.showCropSelectionSection) {
                    this.selectMainCat("Agricultural");
                }
            },
            close: function () {
                this.$emit("close");
            },
        }
    };
</script>

<style lang="scss" scoped>
    .p-card {
        cursor: pointer;
        height: 120px;
        position: relative;

        &--icon {
            width: 50%;
            position: absolute;
            margin: auto;
            left: 50%;
            transform: translateX(-50%);
            bottom: 35px;
        }
    }

    .box {
        border-radius: 25px;
        overflow: hidden;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        height: 100%;
        position: relative;

        &__title {
            color: white;
            position: absolute;
            bottom: 5px;
            z-index: 11;
            text-align: center;
            width: 100%;
            font-size: 16px;
        }

        &:hover {
            box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.24);
        }

        &.active {
            border: 1px solid #009bd1;
        }
    }

    .mask {
        z-index: 10;
        width: 100%;
        height: 100px;
        background-size: cover;
        background-image: url("../../assets/img/shape.png");
    }

    .agriculture {
        &__ct {
            margin-top: 20px;
            margin-bottom: 20px;

            .select-all {
                margin-top: 10px;
            }
        }
    }

    .back {
        width: 10px;
        height: 10px;
        background: url("../../assets/img/icons/back-arrow.svg");
        background-size: contain;
        display: inline-block;
    }

    .list-item {
        padding-left: 5px;
        cursor: pointer;

        &:nth-child(even) {
            background: #edebe5;
        }

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 25px;
        line-height: 25px;
        color: #707070;

        &:hover {
            background: #009bd1;
            color: white;
        }

        &.active {
            background-color: #009bd1;
            color: white;
        }
    }

    .subcategory {
        font-size: 18px;
        margin-bottom: 5px;

        &::before {
            position: relative;
            top: 0;
            content: url("../../assets/img/subcategory.png");
            margin-right: 5px;
            margin-left: 5px;
        }

        &__header {
            cursor: pointer;
            margin-bottom: 20px;
        }
    }

    .category {
        font-size: 18px;
        margin-bottom: 5px;

        &__list {
            max-height: 252px;
            overflow-y: auto;
            margin-bottom: 0;
            padding: 0;
            list-style: none;
            border: 1px solid #edebe5;
        }

        &::before {
            position: relative;
            top: 0;
            content: url("../../assets/img/category.png");
            margin-right: 5px;
            margin-left: 5px;
        }

        &__header {
            cursor: pointer;
            margin-bottom: 20px;
        }
    }

    .vcenter {
        display: flex;
        align-items: center;
    }
</style>
